import DOMPurify from 'dompurify'

import { empty, fetchJSON, toCamelCase, reactToCwp } from '@ampdx/common-utils/src/index'
import { parseSettings, track } from '@cwp/utils'

import { APIENDPOINT, getCWPEnvironmentForURL } from '../../components/shared/utils/common-utils'

import MHeader from '../../components/shared/MicrositeHeader/index'
import MPersonalizedHeader from '../../components/shared/HeaderPersonalized/index'
import MPersonalizedFooter from '../../components/shared/FooterPersonalized/index'
import HeroBackgroundImage from '../../components/shared/Hero/src/HeroImageBackground/index'
import { FooterNavigation as MicrositeFooter } from '@ampdx/component-library/src/components'
import Welcome from '../../components/welcome-kit/Welcome'
import Register from '../../components/welcome-kit/Register'
import Advisor from '../../components/shared/Advisor'
import AnnualReportHeader from '../../components/shared/annual-reports/Header'
import LandingPage from '../../components/shared/annual-reports/LandingPage'
import ConsolidatedHighlights from '../../components/shared/annual-reports/ConsolidatedHighlights/index'
import MicrositeContact from '../../components/shared/MicrositeContact'
import LeadingWealthManager from '../../components/shared/annual-reports/LeadingWealthManager'
import FinancialStrength from '../../components/shared/annual-reports/FinancialStrength'
import AdjustedRevenuesTables from '../../components/shared/annual-reports/AdjustedRevenuesTables'
import MilestoneHighlight from '../..//components/shared/annual-reports/MilestoneHighlight'
import Popover from '../../components/shared/Popover'
import HeaderMicrosite from '../../components/microsite-cms-navigation/Header/index'
import NavigationMicrosite from '../../components/microsite-cms-navigation/Navigation/index'
import CIHeader from '../../components/competitive-intelligence/index'

import { Alert } from '@ampdx/component-library/dist/components/Alert'
import { Article } from '@ampdx/component-library/dist/components/Article'
import { CardCollections as CardCollection } from '@ampdx/component-library/dist/components/CardList'
import { CTA } from '@ampdx/component-library/dist/components/CTA'
import {
  HeroComplex,
  HeroSectionFront,
  HeroTopicFront,
  DynamicHero,
  CardHero,
} from '@ampdx/component-library/dist/components/Hero'

import { TestimonialCarousel } from '@ampdx/component-library/dist/components/TestimonialCarousel'
import {
  TwoColumnBanner as BannerTwoColumn,
  BannerOverlay as BannerOverlayFixHeight,
} from '@ampdx/component-library/dist/components/Banner'
import BannerOneColumn from '../../components/shared/Banner/src/views/BannerOneColumn/index'

import { Promo } from '@ampdx/component-library/dist/components/Promo'
import { Commitments as CommitmentsTab } from '@ampdx/component-library/dist/components/Commitments'
import { AnchorLinks } from '@ampdx/component-library/dist/components/AnchorLinks'
import { SimpleContent } from '@ampdx/component-library/dist/components/SimpleContent/src/SimpleContent'
import { TimeHorizon } from '@ampdx/component-library/dist/components/TimeHorizon'
import { Journey } from '@ampdx/component-library/dist/components/Journey'
import Tabs from '../../components/shared/TabsNextGen/index'
import AccordionNextGen from '../../components/shared/AccordionNextGen'
import { SocialShare } from '@ampdx/component-library/dist/components/SocialShare'
import NextGenAnnualReportHeader from '../../components/shared/annual-reports/AnnualReportNavigation/Header'
import AnnualReportNavigation from '../../components/shared/annual-reports/AnnualReportNavigation/Navigation'
import { LandingHero } from '../../components/shared/annual-reports/LandingHero/LandingHero'
import { IndustryRecognition } from '../../components/shared/annual-reports/IndustryRecognition/IndustryRecognition'
import { IconicCompanies } from '../../components/shared/annual-reports/IconicCompanies/IconicCompanies'
import { ShareholderValue } from '../../components/shared/annual-reports/ShareholderValue/ShareholderValue'
import { BackToTop } from '@ampdx/component-library/dist/components/BackToTop'
const components = {
  AnchorLinks: reactToCwp(AnchorLinks),
  Alert: reactToCwp(Alert),
  Article: reactToCwp(Article),
  BannerOneColumn,
  BannerTwoColumn: reactToCwp(BannerTwoColumn),
  BannerOverlayFixHeight: reactToCwp(BannerOverlayFixHeight),
  CardCollection: reactToCwp(CardCollection),
  CommitmentsTab: reactToCwp(CommitmentsTab),
  CTA: reactToCwp(CTA),
  HeroComplex: reactToCwp(HeroComplex),
  HeroSectionFront: reactToCwp(HeroSectionFront),
  HeroTopicFront: reactToCwp(HeroTopicFront),
  DynamicHero: reactToCwp(DynamicHero),
  Journey: reactToCwp(Journey),
  Promo: reactToCwp(Promo),
  SimpleContent: reactToCwp(SimpleContent),
  TestimonialCarousel: reactToCwp(TestimonialCarousel),
  TimeHorizon: reactToCwp(TimeHorizon),
  MHeader,
  MPersonalizedHeader,
  MPersonalizedFooter,
  HeroBackgroundImage,
  MicrositeFooter: reactToCwp(MicrositeFooter),
  Welcome,
  Register,
  Advisor,
  AnnualReportHeader,
  LandingPage,
  ConsolidatedHighlights,
  MicrositeContact,
  LeadingWealthManager,
  FinancialStrength,
  AdjustedRevenuesTables,
  MilestoneHighlight,
  Popover,
  HeaderMicrosite,
  NavigationMicrosite,
  Tabs,
  CardHero: reactToCwp(CardHero),
  CIHeader,
  AccordionNextGen,
  SocialShare: reactToCwp(SocialShare),
  NextGenAnnualReportHeader,
  AnnualReportNavigation,
  LandingHero: reactToCwp(LandingHero),
  IndustryRecognition: reactToCwp(IndustryRecognition),
  IconicCompanies: reactToCwp(IconicCompanies),
  ShareholderValue: reactToCwp(ShareholderValue),
  BackToTop: reactToCwp(BackToTop),
}

const COMPONENT_ATTR = 'data-is'
const SETTINGS_ATTR = 'data-settings'
const DOCUMENT_ATTR = 'data-document'
const DOCUMENT_REGEX = new RegExp(`^${DOCUMENT_ATTR}`)
const NAMED_DOCUMENT_REGEX = new RegExp(`^${DOCUMENT_ATTR}-`)

// Class added to an element when the component has been initialized
export const loadedClass = 'component-loaded'

/**
 * Queries the DOM for components to initialize
 *
 * @returns {Number} Number of components initialized
 */
export default function loadComponents() {
  const componentsList = Array.from(
    document.querySelectorAll(`[${COMPONENT_ATTR}]:not(.${loadedClass})`)
  )

  componentsList.forEach(async component => {
    try {
      await initComponent(component)
    } catch (e) {
      console.error('Error loading component', e)
    }
  })

  return componentsList.length
}

/**
 * Initializes a component specified by the given DOM element
 *
 * @param {Element} DOM element to initialize
 * @returns {Promise} Resolves with the initialized component
 */
async function initComponent(el) {
  el.classList.add(loadedClass)
  const { name, settings, documentRequests } = parseElement(el)
  return Promise.all([...documentRequests])
    .then(([...documents]) => {
      if (!(name in components)) {
        return
      }

      const Component = components[name]
      let content = parseElementAttributes(el)

      if (documents.length === 1) {
        const doc = documents[0]

        if (!doc.error) {
          content = Object.assign(content, doc.data)
        } else {
          track.error(DOMPurify.sanitize(doc.error))
        }
      } else {
        content = Object.assign(
          content,
          documents.reduce((acc, doc) => {
            if (!doc.error) {
              acc[doc.name] = doc.data
            } else {
              track.error(DOMPurify.sanitize(doc.error))
            }

            return acc
          }, {})
        )
      }

      return new Component(empty(el), {
        ...settings,
        content,
      })
    })
    .catch(() => {
      return null
    })
}

/**
 * Parses the given element to identify the component representation
 *
 * @param {Element} DOM element to parse
 * @returns {Object} Representation of the component
 */
function parseElement(el) {
  const { value: name } = el.attributes[`${COMPONENT_ATTR}`]
  const { value: settings } = el.attributes[`${SETTINGS_ATTR}`] || {}

  return {
    name,
    settings: parseSettings(settings),
    documentRequests: fetchDocuments(el.attributes),
  }
}

/**
 * Parses the attributes on an element so they can be used for configuration
 * @param {Element} DOM element to parse the attributes of
 * @returns {Object} map of attributes from the element
 */
function parseElementAttributes(el) {
  let attributes = {}

  // Direct attributes, like <attribute>=<value>
  Array.from(el.attributes).forEach(attribute => {
    attributes[parseAttributeName(attribute.name)] = attribute.value
  })
  // forceList isn't needed in component level. only used here in the loader
  if (attributes.forceList) delete attributes.forceList
  return Object.assign(attributes, parseChildAttributes(Array.from(el.children)))
}

/**
 * Child attributes, useful for HTML transposition.
 * Looks for: <some-attribute>Value</some-attribute> which would become someAttribute: Value
 * Or: <div data-attribute="someAttribute">Value</div> which will become someAttribute: Value
 * Or: <some-attribute data-object><some-child>Value</some-child></some-attribute> which will become:
 *    someAttribute: { someChild: Value }
 * @param {Array[Element]} Array of DOM elements to parse
 * @returns {Object} map of children and attributes
 */
function parseChildAttributes(children) {
  let attributes = {}

  children
    .filter(child => child.hasAttribute('data-attribute') || child.tagName.includes('-'))
    .forEach(child => {
      const name = child.getAttribute('data-attribute') || parseAttributeName(child.tagName)
      const hasAttributes = child.attributes.length > 0
      // forces list to be array. bug where arrays of length 1 stayed as an object.
      const forceList = child.getAttribute('force-list')
      let val
      if (!hasChildAttributes(child)) {
        val = hasAttributes ? parseElementAttributes(child) : child.innerHTML
      } else {
        val = parseElementAttributes(child)
      }

      if (name in attributes && !Array.isArray(attributes[name])) {
        attributes[name] = [attributes[name]]
      }

      if (name in attributes) {
        attributes[name].push(val)
      } else {
        attributes[name] = forceList ? [val] : val
      }
    })

  return attributes
}

/**
 *
 * @param {String} attribute name
 * @returns {String} camelCase attribute name with prefixes removed
 */
function parseAttributeName(name) {
  if (name.indexOf('-') !== -1) {
    return toCamelCase(name.toLowerCase().replace(/^data-/, ''))
  }
  return name
}

/**
 * Checks if a given element which represents an attribute has child attributes
 * @param {HTMLElement} el
 * @returns {Boolean} whether there are child attributes
 */
function hasChildAttributes(el) {
  return (
    el.hasChildNodes && el.children && el.children[0] && el.children[0].tagName.indexOf('-') !== -1
  )
}

/**
 * Fetch document data for a given NameNodeMap
 *
 * @param {NameNodeMap} Element attributes
 * @returns {Array} Promises resolving with the document data
 */
function fetchDocuments(attrs) {
  // the value passed in should be the content identifier or path to the document
  const urls = Array.from(attrs).filter(attr => DOCUMENT_REGEX.test(attr.name))
  const env = getCWPEnvironmentForURL(window.location.href)
  return urls.map(async ({ name, value }) => {
    const formattedName = name.replace(NAMED_DOCUMENT_REGEX, '')
    const url = `${APIENDPOINT(env).base}halapi/documents/${value}`
    try {
      const data = await fetchJSON(url)
      return { data, name: formattedName }
    } catch (error) {
      return { error, name: formattedName }
    }
  })
}
